import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Constants } from '../../../common/constants';
import { FormComponentBase } from '../../../common/form-component-base';
import { Global } from '../../../common/global';
import { ICompany, ICompanyType, ISeTaxTable } from '../../../services/api/api-model';
import { StaticDataService } from '../../../services/api/static-data.service';

@Component({
  selector: 'app-company-data',
  templateUrl: './company-data.component.html'
})
export class CompanyDataComponent extends FormComponentBase implements OnInit {
  @Input() public company: ICompany;
  @Input()
  public set resetChildFrom(value: boolean) {
    if (value) {
      this.childIsValid = Array(3).fill(true);
      this.childIsDirty = Array(9).fill(false);
    }
  }

  public get branding() {
    return environment.branding;
  }

  public taxCategories: ICompanyType[];
  public taxTables: ISeTaxTable[];
  public isWarningVivible: boolean;

  private originalBankAccountNo: string;
  private warningHasBeenShown = false;

  constructor(private staticDataService: StaticDataService) {
    super();
    this.childIsValid = Array(3).fill(true);
    this.childIsDirty = Array(9).fill(false);
  }

  public ngOnInit(): void {
    this.staticDataService.CompanyType.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: ICompanyType[]) => {
      return (this.taxCategories = data);
    });
    this.staticDataService.DefaultTaxTable.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: ISeTaxTable[]) => {
      this.taxTables = data.filter((taxTable: ISeTaxTable) => {
        return taxTable.Id < 98;
      });
      return this.taxTables;
    });
    this.editModeChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => (this.warningHasBeenShown = false));
    this.isDirtyChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe((dirty: boolean) => {
      if (this.company && !dirty && !this.editMode) {
        this.originalBankAccountNo = this.company.BankAccountNo;
      }
    });
  }

  public onBankAccountNoChanged(): void {
    if (this.editMode && this.company && this.company.HasNetsAgreement && !this.warningHasBeenShown) {
      this.isWarningVivible = true;
    }
    this.onChange();
  }

  public get isGreenland(): boolean {
    return Global.COMPANY && Global.COMPANY.CountryId === Constants.GREENLAND_COUNTRY_ID;
  }

  public get IsSwedenCompany(): boolean {
    return Global.COMPANY && Global.COMPANY.CountryId === Constants.SWEDEN_COUNTRY_ID;
  }

  public onWarningAction(action: string): void {
    if (action !== 'Understood') {
      this.company.BankAccountNo = this.originalBankAccountNo;
    } else {
      this.onChange();
    }

    this.warningHasBeenShown = true;
  }
}
